// website/components/NlpLabTab.jsx
// Query-understanding vacuum. Display/sort/filter stays in Results Lab.

import React from 'react';
import PipelineTraceTab from './PipelineTraceTab';

export default function NlpLabTab() {
  return <PipelineTraceTab embedded />;
}
